<template>
    <div class="flex flex-col gap-8">
        <div class="flex flex-col col-span-12">
            <div class="">
                <div>
                    <legend class="text-slate-600 dark:text-slate-400 text-sm font-medium pb-2">
                        Stay dates
                    </legend>
                    <fieldset>
                        <div class="flex items-start gap-5 mb-2">
                            <label class="flex items-center gap-2 py-2">
                                <input
                                    id="specificdates"
                                    value="specific"
                                    name="alert-type"
                                    v-model="modelValue.alertType"
                                    type="radio"
                                    checked
                                    class="h-4 w-4 border-gray-300 text-orange focus:ring-orange-400"
                                />
                                <span
                                    class="text-gray-900 dark:text-slate-100 text-base font-base leading-6"
                                >
                                    Specific Dates
                                </span>
                            </label>

                            <label class="flex items-center gap-2 py-2">
                                <input
                                    id="flexibledates"
                                    value="flexible"
                                    name="alert-type"
                                    v-model="modelValue.alertType"
                                    type="radio"
                                    class="h-4 w-4 border-gray-300 text-orange focus:ring-orange-400"
                                />
                                <span
                                    class="text-gray-900 dark:text-slate-100 text-base font-base leading-6"
                                >
                                    Flexible Dates
                                </span>
                            </label>
                        </div>
                    </fieldset>
                </div>
            </div>

            <div v-if="modelValue.alertType === 'specific'">
                <SafeDateRangePicker
                    v-model:start-date="modelValue.checkIn"
                    v-model:end-date="modelValue.checkOut"
                    :config="dateConfig"
                    :auto-range-days="1"
                >
                    <template #default="{ openMenu, startValue, endValue }">
                        <div class="flex px-6 py-3 bg-slate-100 dark:bg-slate-700 gap-4 rounded-lg">
                            <div class="w-1/2 min-w-0 flex-1 relative">
                                <UiInput
                                    id="check-in-date"
                                    name="start_date"
                                    label="Check in"
                                    placeholder="Check In"
                                    :options="{
                                        icon: 'calendar',
                                    }"
                                    :errors="formErrors"
                                >
                                    <template #input>
                                        <input
                                            :value="startValue"
                                            readonly
                                            @click="openMenu"
                                            name="start_date"
                                            id="check-in-date"
                                            class="relative block w-full rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-1.5 pl-10 text-gray-900 dark:text-slate-100 placeholder:text-slate-500 dark:placeholder:text-slate-400 focus:z-10 focus:ring-0 focus:border-slate-800 hover:border-slate-800 placeholder:text-sm cursor-pointer"
                                            placeholder="Check in"
                                            :class="{
                                                '!border-red-500':
                                                    formErrors['start_date'],
                                            }"
                                        />
                                    </template>
                                </UiInput>
                            </div>

                            <div class="min-w-0 flex-1 relative">
                                <UiInput
                                    id="check-out-date"
                                    name="end_date"
                                    label="Check out"
                                    placeholder="Check out"
                                    :options="{
                                        icon: 'calendar',
                                    }"
                                    :errors="formErrors"
                                >
                                    <template #input>
                                        <input
                                            :value="endValue"
                                            readonly
                                            @click="openMenu"
                                            name="end_date"
                                            id="check-out-date"
                                            class="relative block w-full rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-1.5 pl-10 text-gray-900 dark:text-slate-100 placeholder:text-slate-500 dark:placeholder:text-slate-400 focus:z-10 focus:ring-0 focus:border-slate-800 hover:border-slate-800 placeholder:text-sm cursor-pointer"
                                            placeholder="Check out"
                                            :class="{
                                                '!border-red-500':
                                                    formErrors['end_date'],
                                            }"
                                        />
                                    </template>
                                </UiInput>
                            </div>
                        </div>
                    </template>
                </SafeDateRangePicker>
            </div>

            <div v-if="modelValue.alertType === 'flexible'">
                <div class="flex px-6 py-3 bg-slate-100 dark:bg-slate-700 gap-4 rounded-lg">
                    <div class="w-1/2 min-w-0 flex-1 relative">
                        <UiInput
                            id="month-year"
                            name="month_year"
                            label="Month"
                            placeholder="Month"
                            :options="{
                                icon: 'calendar',
                            }"
                            :errors="formErrors"
                        >
                            <template v-slot:input>
                                <FlatPickr
                                    :config="monthConfig"
                                    :month-picker="true"
                                    v-model="modelValue.monthYear"
                                    name="month_year"
                                    id="month-year"
                                    class="relative block w-full rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-1.5 pl-10 text-gray-900 dark:text-slate-100 placeholder:text-slate-500 dark:placeholder:text-slate-400 focus:z-10 focus:ring-0 focus:border-slate-800 hover:border-slate-800 placeholder:text-sm"
                                    placeholder="Month"
                                    ref="monthYear"
                                    :class="{
                                        '!border-red-500':
                                            formErrors['month_year'],
                                    }"
                                />
                            </template>
                        </UiInput>
                    </div>
                    <div class="min-w-0 flex-1 relative">
                        <UiInput
                            id="nights"
                            name="nights"
                            label="Nights"
                            :errors="formErrors"
                        >
                            <template v-slot:input>
                                <select
                                    id="nights"
                                    name="nights"
                                    class="w-full rounded border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 py-2 text-left text-sm text-slate-500 dark:text-slate-400 leading-5 focus:ring-0 focus:border-slate-800 hover:border-slate-800"
                                    v-model="modelValue.numberOfNights"
                                    :class="{
                                        '!border-red-500': formErrors['nights'],
                                    }"
                                >
                                    <option value="">Nights number</option>
                                    <option value="1">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                    <option value="8">8</option>
                                    <option value="9">9</option>
                                    <option value="10">10+</option>
                                </select>
                            </template>
                        </UiInput>
                    </div>
                </div>
            </div>
        </div>
        <div>
            <div class="flex flex-col justify-between">
                <div class="mt-2">
                    <UiInput
                        type="number"
                        id="check-in-date"
                        name="number"
                        label="Max points per night"
                        placeholder="Max award points per night"
                        pattern="\d*"
                        step="1"
                        v-model:inputValue="modelValue.maxPoints"
                        :options="{
                            icon: 'building',
                            iconSvgClass: 'fill-none',
                            iconPathClass: 'stroke-slate-800',
                            optional: true,
                        }"
                        :errors="formErrors"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { watch } from 'vue';
import FlatPickr from '@/components/ui/SafeFlatPickr.vue';
import SafeDateRangePicker from '@/components/ui/SafeDateRangePicker.vue';
import UiInput from '@/components/ui/inputs/ui-input.vue';
import dayjs from 'dayjs';

const props = defineProps({
    formErrors: { type: Object },
    modelValue: {
        type: Object,
        required: true,
    },
});

watch(
    () => props.modelValue.monthYear,
    (value) => {
        if (!value) {
            props.modelValue.monthYear = dayjs().startOf('month').format('YYYY-MM');
        }
    },
    { immediate: true }
);

const dateConfig = {
    dateFormat: 'm/d/Y',
    minDate: 'today',
    maxDate: dayjs().add(13, 'month').format('MM/DD/YYYY'),
};

const monthConfig = {
    dateFormat: 'F Y',
    minDate: dayjs().startOf('month').format('YYYY-MM'),
    maxDate: dayjs().add(13, 'month').format('YYYY-MM'),
};

</script>
